import task from 'helpers/task'
import inject from 'helpers/inject'

import appStore from 'stores/AppStore'
import ApiService from 'services/api'

export default task(async function() {
  const api = inject(ApiService)
  const user = await api.request({ url: '/api/accounts/me' })
  appStore.currentUser = user
  return user
}, {
  defaultValue: null
})



// WEBPACK FOOTER //
// ./src/tasks/getCurrentUser.js